@import '~style-sheet-helpers/core.less';
@import (reference) '../../../../constants/spacing.module.less';

.transfer-order-drawer {
  text-align: left;
  max-width: 1480px;
  margin: auto;
}

.drawer-body {
  flex: 1;
  overflow-y: auto;
  background: var(--gray-F9FAFB);
  padding: @space-24;
  margin: @space-0 @space-32 @space-16 @space-32;
}

.drawer-footer {
  flex-shrink: 0;
  border-top: 1px solid var(--grey-300);
  padding: @space-24 @space-48;
  background: var(--white);
  justify-content: flex-end;
}
